export class RolType {
    ROLE_USER = 'role_agent';
    ROLE_ADMIN = 'role_admin';
    ROLE_COORDINATOR = 'role_coordinator';
    ROLE_SUPERADMIN = 'role_superadmin';
    ROLE_ALL = 'role_all';
  }
